/* Edge Customer Acquisition Intelligence — attribution capture (Sprint 4.3).
   Captures first-touch (immutable) + last-touch, first product/collection, device,
   and writes the acquisition story onto the Shopify CART so it lands PERMANENTLY on
   the ORDER — the per-customer system of record. Also exposes the record to Klaviyo
   (via the concierge) and GA4 user_properties. Consent-aware, first-party only.
   Context injected by sections/edge-measurement.liquid as window.EdgeAttrContext. */
(function () {
  'use strict';
  var CFG = window.EdgeTrackConfig || {};
  var CTX = window.EdgeAttrContext || {};
  if (CFG.attributionEnabled === false) return;

  // ---- consent (mirror the measurement layer) ----
  function consentOk() {
    if (!CFG.respectConsent) return true;
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed();
    } catch (e) {}
    return true;
  }

  var KEY = 'edge_cai';
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save(r) { try { localStorage.setItem(KEY, JSON.stringify(r)); } catch (e) {} }
  function cookie(name, val, days) {
    try {
      var d = new Date(); d.setTime(d.getTime() + days * 864e5);
      document.cookie = name + '=' + encodeURIComponent(val) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
    } catch (e) {}
  }
  function nowISO() { try { return new Date().toISOString(); } catch (e) { return ''; } }
  function device() { return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) ? 'mobile' : 'desktop'; }

  function params() {
    var q = {}, s = new URLSearchParams(location.search);
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id','fbclid','gclid'].forEach(function (k) {
      var v = s.get(k); if (v) q[k] = v;
    });
    return q;
  }

  function touch() {
    var p = params();
    return {
      source: p.utm_source || '', medium: p.utm_medium || '',
      campaign: p.utm_campaign || '', content: p.utm_content || '', term: p.utm_term || '',
      id: p.utm_id || '', fbclid: p.fbclid || '', gclid: p.gclid || '',
      landing: location.pathname + location.search,
      referrer: document.referrer || '',
      ts: nowISO(), device: device()
    };
  }
  function hasCampaign(t) { return !!(t.source || t.medium || t.campaign || t.fbclid || t.gclid); }

  var rec = load();
  var t = touch();

  // FIRST TOUCH — set once, NEVER overwritten
  if (!rec.first) {
    rec.first = t;
    cookie('edge_ft', [t.source, t.campaign, t.ts].join('|'), CFG.cookieDays || 180);
  } else if (!hasCampaign(rec.first) && hasCampaign(t)) {
    // upgrade a direct/organic first-touch to the first CAMPAIGN touch (still "first real acquisition")
    rec.first = t;
    cookie('edge_ft', [t.source, t.campaign, t.ts].join('|'), CFG.cookieDays || 180);
  }
  // LAST TOUCH — always refreshed on a campaigned visit
  if (hasCampaign(t) || !rec.last) rec.last = t;

  // First product / collection viewed
  if (CTX.product && !rec.first_product) rec.first_product = { id: CTX.product.id, handle: CTX.product.handle, title: CTX.product.title, ts: nowISO() };
  if (CTX.collection && !rec.first_collection) rec.first_collection = { handle: CTX.collection.handle, title: CTX.collection.title, ts: nowISO() };

  save(rec);

  // ---- public API (consumed by the concierge for Klaviyo, and by Edge OS) ----
  window.EdgeAttribution = {
    get: function () { return load(); },
    setGiftSelf: function (v) { var r = load(); if (!r.gift_self) { r.gift_self = v; save(r); syncCart(true); } },
    toKlaviyo: function () {
      var r = load(), f = r.first || {};
      return {
        first_utm_source: f.source || '', first_utm_medium: f.medium || '',
        first_utm_campaign: f.campaign || '', first_utm_content: f.content || '',
        first_utm_term: f.term || '', first_landing_page: f.landing || '',
        first_referrer: f.referrer || '', first_visit_date: f.ts || '',
        first_device: f.device || '', acquisition_gift_self: r.gift_self || ''
      };
    }
  };

  // ---- write attribution to the Shopify cart -> becomes ORDER attributes (permanent) ----
  function attrs() {
    var r = load(), f = r.first || {}, l = r.last || {};
    var a = {};
    function put(k, v) { if (v) a[k] = String(v); }
    put('Edge First Source', f.source); put('Edge First Medium', f.medium);
    put('Edge First Campaign', f.campaign); put('Edge First Ad', f.content);
    put('Edge First Audience', f.term); put('Edge Landing Page', f.landing);
    put('Edge Referrer', f.referrer); put('Edge First Visit', f.ts);
    put('Edge First Device', f.device); put('Edge fbclid', f.fbclid);
    put('Edge Last Source', l.source); put('Edge Last Campaign', l.campaign);
    put('Edge First Product', r.first_product && r.first_product.title);
    put('Edge First Collection', r.first_collection && r.first_collection.title);
    put('Edge Gift/Self', r.gift_self);
    return a;
  }
  function syncCart(force) {
    if (!consentOk()) return;
    var a = attrs();
    if (!Object.keys(a).length) return;
    var sig = JSON.stringify(a);
    try {
      if (!force && sessionStorage.getItem('edge_cai_synced') === sig) return;
      sessionStorage.setItem('edge_cai_synced', sig);
    } catch (e) {}
    try {
      fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: a })
      }).catch(function () {});
    } catch (e) {}
  }

  // ---- GA4 user properties + paid landing signal ----
  function ga4() {
    if (!consentOk()) return;
    var f = (load().first) || {};
    try { if (typeof window.gtag === 'function') window.gtag('set', 'user_properties', {
      first_source: f.source || '', first_campaign: f.campaign || '', first_device: f.device || ''
    }); } catch (e) {}
    if (hasCampaign(t) && /paid|cpc|ppc/i.test(t.medium) && window.EdgeTrack) {
      window.EdgeTrack.event('paid_landing_view', { source: t.source, campaign: t.campaign, ad: t.content, audience: t.term });
    }
  }

  // run after consent is resolvable
  function run() { syncCart(false); ga4(); }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
